import TopNav from '@/pages/home/components/TopNav';
import UpdateTicker from '@/pages/home/components/UpdateTicker';
import HeroSection from '@/pages/home/components/HeroSection';
import FeaturedStrip from '@/pages/home/components/FeaturedStrip';
import TopicWall from '@/pages/home/components/TopicWall';
import LatestFeed from '@/pages/home/components/LatestFeed';
import CommunityBuzz from '@/pages/home/components/CommunityBuzz';
import TrustSection from '@/pages/home/components/TrustSection';
import FaqSection from '@/pages/home/components/FaqSection';
import SiteFooter from '@/pages/home/components/SiteFooter';

export default function Home() {
  return (
    <div id="top" className="min-h-screen flex flex-col bg-background-50">
      <header className="sticky top-0 z-50">
        <UpdateTicker />
        <TopNav />
      </header>

      <main className="flex-1">
        <HeroSection />
        <FeaturedStrip />
        <TopicWall />
        <LatestFeed />
        <CommunityBuzz />
        <TrustSection />
        <FaqSection />
      </main>

      <SiteFooter />
    </div>
  );
}